var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarIconsPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.576 3.696 4.223 2.134c-.156-.18-.442-.179-.623.003L2.487 3.252c-.33.331-.426.823-.234 1.218a11.682 11.682 0 0 0 5.424 5.432c.394.192.886.097 1.217-.235l1.124-1.125c.182-.182.182-.47 0-.626L8.45 6.571c-.163-.141-.418-.123-.583.042l-.545.546a.185.185 0 0 1-.221.035 5.822 5.822 0 0 1-2.144-2.146.185.185 0 0 1 .035-.222l.544-.544c.165-.166.183-.422.04-.586v0z",
    stroke: "#7E7E7E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsPhone);
export default __webpack_public_path__ + "static/media/akar-icons_phone.7500b2cfb027174e635624d55991c340.svg";
export { ForwardRef as ReactComponent };